const externalResourceIconOptions = [
  { value: 'slack', label: 'Slack', icon: 'brand-slack', iconLibrary: 'tabler' },
  { value: 'linkedin', label: 'LinkedIn', icon: 'brand-linkedin', iconLibrary: 'tabler' },
  { value: 'github', label: 'GitHub', icon: 'brand-github', iconLibrary: 'tabler' },
  { value: 'youtube', label: 'YouTube', icon: 'brand-youtube', iconLibrary: 'tabler' },
  { value: 'link', label: 'URL Link', icon: 'link', iconLibrary: 'material' },
  { value: 'globe', label: 'Website', icon: 'globe', iconLibrary: 'material' },
  { value: 'bookmarks', label: 'Bookmarks', icon: 'bookmarks', iconLibrary: 'material' },
  { value: 'folder', label: 'Folder', icon: 'folder', iconLibrary: 'material' },
];

const externalResourceIconMap = Object.fromEntries(
  externalResourceIconOptions.map((o) => [o.value, o])
);

export {
  externalResourceIconOptions,
  externalResourceIconMap,
};
